<template>
    <Box title="资产列表" :SearchParams="SearchIsSee" @SearchParams="SearchIsSee = true">

        <transition-group name="fade">
            <div class="menu" v-show="SearchIsSee" key="1">
                <Field title="资产名称" placeholder="请输入名称/编号" @onMessage="(value) => (search.EquipmentName = value)" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition-group>

        <van-tabs @click="propconfirm" swipeable background="rgba(0,0,0,0)" line-width="20px" v-model="tabsIndex">
            <van-tab :title="'全部(' + Total + '台)'">
                <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee = false">
                    <div class="ArrayItems items" v-for="item in list"
                        @click="$router.push({ name: 'InventoryEquipment', params: { item, BtnUpdateState: true, BtnSaveState: false, ImgState: true, PageState: true } })">
                        <div>
                            <img src="@/assets/img/Icon_1.png" />
                            <div>
                                <div>
                                    <span class="ellipsis">{{ item.AssetName }}</span>
                                    <img src="../../assets/img/right.png" />
                                </div>
                                <div>
                                    <div>
                                        <p>资产编号:</p>
                                        <p>使用科室:</p>
                                        <p>设备型号:</p>
                                        <p>资产状态:</p>
                                        <p>存放地点:</p>
                                    </div>
                                    <div>
                                        <p class="ellipsis">{{ item.AssetNo }}</p>
                                        <p class="ellipsis">{{ item.DepartmentName }}</p>
                                        <p class="ellipsis">{{ item.AssetSize }}</p>
                                        <p class="ellipsis">{{ item.AssetStateName }}</p>
                                        <p class="ellipsis">{{ item.Location }}</p>

                                    </div>
                                    <div class="button">
                                        <div>盘点</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <span>盘点状态</span>
                            <span>{{ item.InventoryState == "0" ? "未盘点" : "已盘点" }}</span>
                        </div>
                    </div>
                </LoadingFooter>
            </van-tab>
            <van-tab :title="'已盘点(' + TotalSecond + '台)'">
                <LoadingFooter v-model="loadingSecond" :finished="finishedSecond" @load="onLoadSecond"
                    @scroll="IsSeeSecond = false">
                    <!-- <transition name="fade">
            <div class="menu" v-show="IsSeeSecond" key="1">
              <Field title="设备名称" placeholder="请输入设备名称" @onMessage="(value) => (searchSecond.EquipmentName = value)" />
              <div class="search" @click="serach">查询</div>
            </div>
          </transition> -->
                    <div class="ArrayItems items" v-for="item in listSecond"
                        @click="$router.push({ name: 'InventoryEquipment', params: { item, BtnUpdateState: item.JLZT == '0', BtnSaveState: item.JLZT == '0', ImgState: item.JLZT == '0', PageState: false } })">
                        <div>
                            <img src="@/assets/img/Icon_1.png" />
                            <div>
                                <div>
                                    <span class="ellipsis">{{ item.AssetName }}</span>
                                    <img src="../../assets/img/right.png" />
                                </div>
                                <div>
                                    <div>
                                        <p>资产编号:</p>
                                        <p>使用科室:</p>
                                        <p>设备型号:</p>
                                        <p>资产状态:</p>
                                        <p>存放地点:</p>
                                    </div>
                                    <div>
                                        <p class="ellipsis">{{ item.AssetNo }}</p>
                                        <p class="ellipsis">{{ item.DepartmentName }}</p>
                                        <p class="ellipsis">{{ item.AssetSize }}</p>
                                        <p class="ellipsis">{{ item.AssetStateName }}</p>
                                        <p class="ellipsis">{{ item.Location }}</p>

                                    </div>
                                    <div class="button">
                                        <div>盘点</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <span>盘点状态</span>
                            <span>{{ item.InventoryState == "0" ? "未盘点" : "已盘点" }}</span>
                        </div>
                    </div>
                </LoadingFooter>
            </van-tab>
            <van-tab :title="'未盘点(' + TotalThird + '台)'">
                <LoadingFooter v-model="loadingThird" :finished="finishedThird" @load="onLoadThird"
                    @scroll="IsSeeThird = false">
                    <!-- <transition name="fade">
            <div class="menu" v-show="IsSeeThird" key="1">
              <Field title="设备名称" placeholder="请输入设备名称" @onMessage="(value) => (searchThird.EquipmentName = value)" />
              <div class="search" @click="serach">查询</div>
            </div>
          </transition> -->
                    <div class="ArrayItems items" v-for="item in listThird"
                        @click="$router.push({ name: 'InventoryEquipment', params: { item, BtnUpdateState: item.JLZT == '0', BtnSaveState: item.JLZT == '0', ImgState: item.JLZT == '0', PageState: false } })">
                        <div>
                            <img src="@/assets/img/Icon_1.png" />
                            <div>
                                <div>
                                    <span class="ellipsis">{{ item.AssetName }}</span>
                                    <img src="../../assets/img/right.png" />
                                </div>
                                <div>
                                    <div>
                                        <p>资产编号:</p>
                                        <p>使用科室:</p>
                                        <p>设备型号:</p>
                                        <p>资产状态:</p>
                                        <p>存放地点:</p>
                                    </div>
                                    <div>
                                        <p class="ellipsis">{{ item.AssetNo }}</p>
                                        <p class="ellipsis">{{ item.DepartmentName }}</p>
                                        <p class="ellipsis">{{ item.AssetSize }}</p>
                                        <p class="ellipsis">{{ item.InventoryEquStateName }}</p>
                                        <p class="ellipsis">{{ item.Location }}</p>

                                    </div>
                                    <div class="button">
                                        <div>盘点</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <span>盘点状态</span>
                            <span>{{ item.InventoryState == "0" ? "未盘点" : "已盘点" }}</span>
                        </div>
                    </div>
                </LoadingFooter>
            </van-tab>
        </van-tabs>
    </Box>
</template>

<script>
    import {
        ExistsEdorIng
    } from "../../../tool/api/api.js";
    import {
        Tab,
        Tabs
    } from "vant";
    import Box from "@/components/commonBox/commonBox";
    import Field from "../../components/field/field";
    import LoadingFooter from "../../components/loadingFooter/loadingFooter";
    export default {
        name: "InventoryDetail",
        data() {
            return {
                search: {
                    EquipmentName: null
                },
                SearchIsSee: false,
                loading: true,
                finished: false,
                list: [],
                touchStartY: 0,
                IsSee: false,
                page: 10,
                Total: 0,
                tabsIndex: 0, //选项卡默认选中
                listSecond: [], //已盘点列表
                loadingSecond: false,
                finishedSecond: false,
                listThird: [], //未盘点列表
                loadingThird: false,
                finishedThird: false,
                pageScond: 1,
                TotalSecond: 0,
                pageThird: 1,
                TotalThird: 0,
                touchStartYSecond: 0, //已执行滚动条滚动数值
                IsSeeSecond: false, //已执行 是否展示
                IsSeeThird: false,
                InventoryNo: this.$route.params.item.InventoryNo
            };
        },
        components: {
            Box,
            Field,
            LoadingFooter,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
        },
        activated() {
            this.serach();
        },
        methods: {
            serach() {
                this.SearchIsSee = false;
                if (this.tabsIndex === 0) {
                    this.IsSee = false;
                    this.list = [];
                    this.page = 1;
                    this.loadDataDefault();
                } else if (this.tabsIndex === 1) {
                    this.IsSeeSecond = false;
                    this.listSecond = [];
                    this.pageScond = 1;
                    this.loadHasBeenInventory();
                } else {
                    this.IsSeeThird = false;
                    this.listThird = [];
                    this.pageThird = 1;
                    this.loadNoInventory();
                }
            },
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 1;
                    this.loadDataDefault();
                }
            },
            loadDataDefault() {
                this.$post("api/Inventory/GetInventoryItemList", {
                    InventoryNo: this.InventoryNo,
                    EquipmentName: this.search.EquipmentName,
                    PageIndex: this.page,
                    PageSize: 10,
                }).then((result) => {
                    this.Total = result.Total;
                    this.TotalSecond = result.HasInventory;
                    this.TotalThird = result.NoInventory;
                    for (let i = 0; i < result.InventoryItemList.length; i++) {
                        this.list.push(result.InventoryItemList[i]);
                    }
                    if (this.page * 10 > this.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else this.loading = false;
                });
            },
            /*************************已检测**************************************/
            propconfirm() {
                if (this.tabsIndex == 0) {
                    this.IsSee = false;
                    this.list = [];
                    this.loadDataDefault();
                } else if (this.tabsIndex == 1) {
                    this.IsSeeSecond = false;
                    this.listSecond = [];
                    this.loadHasBeenInventory();
                } else {
                    this.IsSeeThird = false;
                    this.listThird = [];
                    this.loadNoInventory();
                }
            },
            loadHasBeenInventory() {
                this.$post("api/Inventory/GetInventoryItemList", {
                    InventoryNo: this.InventoryNo,
                    EquipmentName: this.serach.EquipmentName,
                    InventoryState: "1",
                    pageIndex: this.pageScond,
                    pageSize: 10,
                }).then((result) => {
                    this.Total = result.Total;
                    this.TotalSecond = result.HasInventory;
                    this.TotalThird = result.NoInventory;
                    for (let i = 0; i < result.InventoryItemList.length; i++) {
                        this.listSecond.push(result.InventoryItemList[i]);
                    }
                    if (this.pageScond * 10 > this.TotalSecond) {
                        this.loadingSecond = false;
                        this.finishedSecond = true;
                    } else this.loadingSecond = false;
                });
            },
            loadNoInventory() {
                this.$post("api/Inventory/GetInventoryItemList", {
                    InventoryNo: this.InventoryNo,
                    EquipmentName: this.serach.EquipmentName,
                    InventoryState: "0",
                    pageIndex: this.pageThird,
                    pageSize: 10,
                }).then((result) => {
                    this.Total = result.Total;
                    this.TotalSecond = result.HasInventory;
                    this.TotalThird = result.NoInventory;
                    for (let i = 0; i < result.InventoryItemList.length; i++) {
                        this.listThird.push(result.InventoryItemList[i]);
                    }
                    if (this.pageThird * 10 > this.TotalThird) {
                        this.loadingThird = false;
                        this.finishedThird = true;
                    } else this.loadingThird = false;
                });
            },
            onLoadSecond() {
                if (!this.loadingSecond && !this.finishedSecond) {
                    this.pageScond += 1;
                    this.loadHasBeenInventory();
                }
            },
            onLoadThird() {
                if (!this.loadingThird && !this.finishedThird) {
                    this.pageThird += 1;
                    this.loadNoInventory();
                }
            }
        },
    };
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;
        margin-top: 100px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #f3f3f3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #efefef;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;
                        flex: 1;

                        &>div {
                            display: flex;

                            &:first-child {
                                margin-bottom: 18px;
                                display: flex;

                                span:first-child {
                                    color: $TEXT-DARK-COLOR;
                                    font-weight: bold;
                                    font-size: 32px;
                                    flex: 1;
                                    width: 208px;
                                }

                                span:nth-child(2) {
                                    color: $TEXT-DARK-COLOR;
                                    font-size: 28px;
                                    margin-left: 10px;
                                    width: 158px;
                                    text-align: right;
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                    margin-left: 10px;
                                }
                            }

                            &:nth-child(2) {
                                p {
                                    color: #999;
                                    font-size: 26px;
                                    line-height: 45px;
                                    height: 45px;
                                }

                                &>div:nth-child(2) {
                                    p {
                                        width: 200px;
                                    }
                                }
                            }
                        }

                        .button {
                            margin-left: 10px;
                            margin-top: 20px;

                            div {
                                width: 152px;
                                height: 60px;
                                border-radius: 30px;
                                background: $THEME-COLOR;
                                font-size: 26px;
                                color: #fff;
                                text-align: center;
                                line-height: 60px;
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1;
                    }
                }
            }
        }
    }

    .listLength {
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: 18px;
        margin-left: 30px;

        span {
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }

    .ArrayItems:nth-child(1) {
        margin-top: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/page/Inventory/InventoryDetail.vue